import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../../store/auth-context';
import { GlobalContext } from '../../../store/global-context';
import { ServiceRequestContext } from '../../../store/service-request';
import { errorMessage } from '../../Util/errorMessage';
const ServiceRequestRootLayout = () => {
    const authCtx = useContext(AuthContext);
    const globalCtx = useContext(GlobalContext);
    const [listOfRequestTypes, setListOfRequestTypes] = useState([]);
    const [listOfServiceRequests, setListOfServiceRequests] = useState([]);
    const [listOfStages, setListOfStages] = useState([]);
    const [selectedRequest, setSelectedRequest] = useState();
    const [listOfCompanies, setListOfCompanies] = useState([]);
    const [listOfDistictValues, setListOfDistictValues] = useState({
      created_on_list:[],
      request_id_list:[],
      stages_list:[]
    });
    useEffect(() => {
        axios
      .get("/api/user/service-request-details", {
        headers: { Authorization: "Bearer " + authCtx.authTokens.access },
      })
      .then((res) => {
        setListOfRequestTypes(res.data.request_types);
        setListOfStages(res.data.stages);
        setListOfDistictValues({created_on_list:res.data.created_on_list,request_id_list:res.data.request_id_list,stages_list:res.data.stages_list});
        setListOfServiceRequests(res.data.service_request_details);
      })
      .catch((e) => {
        globalCtx.raiseAlert(errorMessage(e), "error");
      });

      axios.get(`/api/operations/get-companies`, {
        headers: { Authorization: "Bearer " + authCtx.authTokens.access },
      })
        .then(response => {
          setListOfCompanies(response.data.map((item) => ({label:item.company_name,value:item.id})));
        })
        .catch((e) => {
          globalCtx.raiseAlert(errorMessage(e), "error");
        });
    },[])

    const serviceCtx = {
        listOfStages:listOfStages,
        listOfRequestTypes:listOfRequestTypes,
        listOfServiceRequests:listOfServiceRequests,
        selectedRequest:selectedRequest,
        listOfCompanies:listOfCompanies,
        listOfDistictValues:listOfDistictValues,
        setListOfServiceRequests:setListOfServiceRequests,
        setSelectedRequest:setSelectedRequest
    }

    return (
        <ServiceRequestContext.Provider value={serviceCtx}>
            <Outlet />
        </ServiceRequestContext.Provider>
    )
}

export default ServiceRequestRootLayout;
